const doc = [({"da":({"js":({"admin":({"logs":({"headers":({"create":({"create":"Oprettet"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;